import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { auth, firestore } from '../firebase'; // Ensure Firebase is initialized

const RegisterScreen = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    studentNumber: '',
    faculty: '',
    department: '',
  });
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(false);

//  const auth = getAuth(firebase);
//  const firestore = getFirestore(firebase);
//  const storage = getStorage(firebase);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setPhoto(e.target.files[0]);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { name, email, password, studentNumber, faculty, department } = formData;
    if (!name || !email || !password || !studentNumber || !faculty || !department) {
      alert('Please fill all fields');
      setLoading(false);
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
/*
      let profilePictureUrl = '';
      if (photo) {
        const storageRef = ref(storage, `students/${user.uid}/profile.jpg`);
        await uploadBytes(storageRef, photo);
        profilePictureUrl = await getDownloadURL(storageRef);
      }
*/
      await setDoc(doc(firestore, 'students', user.uid), {
        name,
        email,
        studentNumber,
        faculty,
        department,
      //  profilePicture: profilePictureUrl,
      });

      alert('Registration successful!');
    } catch (error) {
      alert(error.message);
    }
    setLoading(false);
  };

  return (
    <div className="register-container">
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <input type="text" name="name" placeholder="Name" onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
        <input type="password" name="password" placeholder="Password" onChange={handleChange} required />
        <input type="text" name="studentNumber" placeholder="Student Number" onChange={handleChange} required />
        <input type="text" name="faculty" placeholder="Faculty" onChange={handleChange} required />
        <input type="text" name="department" placeholder="Department" onChange={handleChange} required />
        <input type="file" accept="image/*" onChange={handleFileChange} />
        {photo && <img src={URL.createObjectURL(photo)} alt="Preview" className="preview" />}
        <button type="submit" disabled={loading}>{loading ? 'Registering...' : 'Register'}</button>
      </form>
    </div>
  );
};

export default RegisterScreen;
